import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import React from 'react';
function AppContainer(props) {
    const { children } = props;
    return (_jsx("div", { css: css `
        max-width: 500px;
        margin: 0 auto;
        height: 100%;
      `, children: children }));
}
export default AppContainer;
